import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useClientAuth } from '../../contexts/ClientAuthContext';
import axios from 'axios';
import '../../styles/client/ClientDashboard.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ClientProperty = () => {
  const navigate = useNavigate();
  const { token, logout, isAuthenticated } = useClientAuth();
  
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/client/login');
      return;
    }
    fetchProperty();
  }, [isAuthenticated]);

  const fetchProperty = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/client-portal/property`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      setProperty(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur chargement propriété:', error);
      if (error.response?.status === 401) {
        logout();
        navigate('/client/login');
      }
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/client/login');
  };

  if (loading) {
    return (
      <div className="client-dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="client-dashboard-page">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>🌿 NVF - Espace Client</h1>
          <button onClick={handleLogout} className="btn-logout">
            🚪 Déconnexion
          </button>
        </div>
      </header>

      <nav className="dashboard-nav">
        <Link to="/client/dashboard" className="nav-item">
          🏠 Tableau de bord
        </Link>
        <Link to="/client/quotes" className="nav-item">
          📋 Mes devis
        </Link>
        <Link to="/client/property" className="nav-item active">
          🌱 Ma propriété
        </Link>
      </nav>

      <div className="dashboard-container">
        <div className="page-header">
          <h2>🌱 Ma propriété</h2>
          <p>Informations sur votre terrain</p>
        </div>

        <div className="property-info-card">
          <h3>🏠 Adresse</h3>
          <div className="property-detail">
            <p className="property-address">{property?.adresse}</p>
            <p className="property-city">{property?.ville}, {property?.code_postal}</p>
          </div>
        </div>

        <div className="property-info-card">
          <h3>📏 Superficie du terrain</h3>
          <div className="property-detail">
            <p className="property-area">
              <strong>{property?.superficie_terrain?.toLocaleString() || 0}</strong> pieds carrés
            </p>
          </div>
        </div>

        {property?.propertyCoordinates && property.propertyCoordinates.length > 0 && (
          <div className="property-info-card">
            <h3>🗺️ Carte de la propriété</h3>
            <p className="coming-soon">🚧 Carte interactive disponible prochainement</p>
          </div>
        )}

        <div className="property-info-card">
          <h3>ℹ️ Note</h3>
          <p>Pour toute modification concernant votre propriété, veuillez nous contacter:</p>
          <p>📞 <strong>450-XXX-XXXX</strong></p>
          <p>📧 <strong>info@nvfertilisation.com</strong></p>
        </div>
      </div>
    </div>
  );
};

export default ClientProperty;
